<template>
    <li :class="{ 'rise_move': rise, 'down_move': down }">
        <div class="qh_intro">
            <div class="qh_img">
                <img :src="itemData[12]" />
            </div>
            <div class="qh_name">{{itemData[11]}}</div>
        </div>
        <div :class="[itemData[2] < 0 ? 'green' : '', 'qh_price']">{{itemData[0]}}</div>
        <div :class="[itemData[2] < 0 ? 'green' : '', 'qh_price']">{{itemData[2] > 0 ? '+'+itemData[2] : itemData[2]}}%</div>
    </li>
</template>

<script>
export default {
    name: "stockOne",
    props: {
        itemData: Array,
        pricenow: String,
    },
    data(){
        return{
            rise:false,
            down:false,
        }
    },
    watch: {//监听现价变化调用动画
        pricenow: {
            handler(newValue, oldValue) {
                if(oldValue < newValue)
                {
                    this.rise = true;
                    this.down = false;
                }else if(oldValue > newValue){
                    this.down = true;
                    this.rise = false;
                }
                setTimeout(()=>{
                    this.down = false;
                    this.rise = false;
                },2500)
            },
            deep: true//监听父组件数据变化
        },
    },
}
</script>

<style scoped>
    li{
        padding-left: 12px;
        padding-right: 14px;
        display: flex;
        height: 51px;
        line-height: 51px;
        justify-content: space-between;
        border-bottom: 1px solid #EBEBEB;
        background: #ffffff;
    }

    .qh_intro{
        display: flex;
        width: 160px;
    }

    .qh_img{
        display: flex;
        align-items: center;
        margin-right: 7px;
    }

    .qh_img img{
        width: 24px;
        height: 16px;
    }
    .qh_name{
        font-size: 15px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        white-space: nowrap;
    }
    .qh_price{
        font-size: 16px;
        font-family: DINPro-Bold, DINPro;
        font-weight: bold;
        color: #FE484A;
        width: 75px;
        text-align: right;
    }
    .green{
        color: #09C990;
    }

    .rise_move{
        padding-left: 12px;
        padding-right: 14px;
        display: flex;
        height: 51px;
        line-height: 51px;
        justify-content: space-between;
        border-bottom: 1px solid #EBEBEB;
        animation:mymoverise 2s;
        -webkit-animation:mymoverise 2s;
    }

    .down_move{
        padding-left: 12px;
        padding-right: 14px;
        display: flex;
        height: 51px;
        line-height: 51px;
        justify-content: space-between;
        border-bottom: 1px solid #EBEBEB;
        animation:mymovedown 2s;
        -webkit-animation:mymovedown 2s;
    }

    .down_move_animation{
        animation: mymove 2s;
        -webkit-animation: 2s;
    }

    @keyframes mymovedown
    {
        from {background:#DDFBE7;}
        to {background:#ffffff;}
    }

    @-webkit-keyframes mymovedown
    {
        from {background:#DDFBE7;}
        to {background:#ffffff;}
    }
    @keyframes mymoverise
    {
        from {background:#FDDFDF;}
        to {background:#ffffff;}
    }

    @-webkit-keyframes mymoverise
    {
        from {background:#FDDFDF;}
        to {background:#ffffff;}
    }


</style>